import { render, staticRenderFns } from "./ViewGroupMembers.vue?vue&type=template&id=4b810e3f&scoped=true&"
import script from "./ViewGroupMembers.vue?vue&type=script&lang=js&"
export * from "./ViewGroupMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b810e3f",
  null
  
)

export default component.exports